<mat-form-field class="no-truncate" [class]="config?.alignment ?? GridCellContentAlignment.Left">
  <div class="textField">
    <input
      #input
      matInput
      [placeholder]="context.column.placeholder && !context.data[context.column.columnDef] ? context.column.placeholder : ''"
      [(ngModel)]="context.data[context.column.columnDef]"
      [autofocus]="config?.autofocus"
      [maxlength]="config?.options?.maxLength ?? infinity"
      [disabled]="!context.cell.allowEditing"
    />
  </div>
</mat-form-field>
